module.exports = "img/settings.78c255a.png";